import gql from 'graphql-tag'
import DocumentsFragment from '../queries/DocumentsFragment'

export default gql`
  mutation regenerate1919s($input: Regenerate1919sInput!) {
    regenerate1919s(input: $input) {
      document {
        ${DocumentsFragment}
      }
    }
  }
`
